module.exports = __webpack_public_path__ + "static/img/no.92ffe93b.png";